import {useMemo, type ReactNode} from 'react';
import {
  HomeDataContext as SharedHomeDataContext,
  HomeEnvProvider,
  useHomeDataState,
} from '@chekin/shared/home';
import {useUpsellItems} from './useUpsellItems';
import {useGuestappHomeEnv} from './useGuestappHomeEnv';
import {HomeDataContext, type HomeData} from './useHomeData';

type HomeDataProviderProps = {
  children: ReactNode;
};

function GuestappHomeData({children}: HomeDataProviderProps) {
  const shared = useHomeDataState();
  const {items: upsellItems, isLoading: upsellLoading} = useUpsellItems();

  const value = useMemo<HomeData>(
    () => ({...shared, upsellItems, upsellLoading}),
    [shared, upsellItems, upsellLoading],
  );

  return (
    <SharedHomeDataContext.Provider value={shared}>
      <HomeDataContext.Provider value={value}>{children}</HomeDataContext.Provider>
    </SharedHomeDataContext.Provider>
  );
}

export function HomeDataProvider({children}: HomeDataProviderProps) {
  const env = useGuestappHomeEnv();

  return (
    <HomeEnvProvider value={env}>
      <GuestappHomeData>{children}</GuestappHomeData>
    </HomeEnvProvider>
  );
}
